<ul class="list-none p-0 m-0">
    <li *ngIf="companyType==CompanyType.PHYSICAL" class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
        <div class="text-500 w-full md:w-5 font-medium">Zaświadczenie z Krajowego Rejestru Karnego [w formie pliku ZIP]*
            <i class="pi pi-info-circle" pTooltip="Zaświadczenie z Krajowego Rejestru Karnego o niekaralności za przestępstwa, o których mowa w art. 59da ust. 2 pkt 1 ustawy z dnia 12 maja 2011 r. o kredycie konsumenckim w formacie zip (plik zip zawiera: XADES, dokument XML oraz dokument PDF) składa pośrednik kredytowy będący osobą fizyczną." aria-hidden="true"></i>
        </div>
        <div class="text-900 w-full md:w-6 md:flex-order-0 flex-order-1">
            <p-fileUpload #krkForm mode="advanced" accept=".zip"
                          [ngClass]="{'p-error' : attachmentsFormDirty && !krkFile}"
                          (onRemove)="fileRemove(AttachmentType.KRK, krkForm)"
                          [customUpload]="true" [auto]="true"
                          (uploadHandler)="uploadHandler($event, krkForm, AttachmentType.KRK)" chooseLabel="Dodaj plik"
                          [maxFileSize]=10000000
                          invalidFileTypeMessageSummary="{0}: Niepoprawny typ pliku"
                          invalidFileTypeMessageDetail="dopuszczalny typ: zip"
                          invalidFileSizeMessageSummary="{0}: Przekroczony rozmiar pliku"
                          invalidFileSizeMessageDetail="maksymalny rozmiar pliku: {0}">
            </p-fileUpload>
            <small *ngIf="attachmentsFormDirty && !krkFile" class="p-error">
                Brak pliku zaświadczenia z KRK
            </small>
        </div>
    </li>
    <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
        <div class="text-500 w-full md:w-5 font-medium">Potwierdzenie opłaty za wniosek na  nr rachunku: 21 1010 0068 6800 0000 0000 0012 kwota 600 zł [PDF]*
            <i class="pi pi-info-circle" pTooltip="Dowód uiszczenia opłaty w wysokości 600 zł za wniosek o wpis do rejestru, o której mowa w art. 59dc, na rachunek Urzędu Komisji Nadzoru Finansowego, nr rachunku: 21 1010 0068 6800 0000 0000 0012." aria-hidden="true"></i>
        </div>
        <div class="text-900 w-full md:w-6 md:flex-order-0 flex-order-1">
            <p-fileUpload #paymentForm mode="advanced" accept="application/pdf"
                          [ngClass]="{'p-error' : attachmentsFormDirty && !paymentFile}"
                          (onRemove)="fileRemove(AttachmentType.PAYMENT, paymentForm)"
                          [customUpload]="true" [auto]="true"
                          (uploadHandler)="uploadHandler($event, paymentForm, AttachmentType.PAYMENT)" chooseLabel="Dodaj plik"
                          [maxFileSize]=10000000
                          invalidFileTypeMessageSummary="{0}: Niepoprawny typ pliku"
                          invalidFileTypeMessageDetail="dopuszczalny typ: pdf"
                          invalidFileSizeMessageSummary="{0}: Przekroczony rozmiar pliku"
                          invalidFileSizeMessageDetail="maksymalny rozmiar pliku: {0}">
            </p-fileUpload>
            <small *ngIf="attachmentsFormDirty && !paymentFile" class="p-error">
                Brak pliku z opłatą za wniosek
            </small>
        </div>
    </li>
    <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
        <div class="text-500 w-full md:w-5 font-medium">Aktualny odpis z {{companyType==CompanyType.PHYSICAL ? 'Centralnej Ewidencji i Informacji o Działalności Gospodarczej (CEIDG)' : 'Krajowego Rejestru Sądowego (KRS)'}} [PDF]*</div>
        <div class="text-900 w-full md:w-6 md:flex-order-0 flex-order-1">
            <p-fileUpload #registerForm mode="advanced" accept="application/pdf"
                          [ngClass]="{'p-error' : attachmentsFormDirty && !registerFile}"
                          (onRemove)="fileRemove(AttachmentType.REGISTER, registerForm)"
                          [customUpload]="true"
                          [auto]="true"
                          (uploadHandler)="uploadHandler($event, registerForm, AttachmentType.REGISTER)" chooseLabel="Dodaj plik"
                          [maxFileSize]="10000000"
                          invalidFileTypeMessageSummary="{0}: Niepoprawny typ pliku"
                          invalidFileTypeMessageDetail="dopuszczalny typ: pdf"
                          invalidFileSizeMessageSummary="{0}: Przekroczony rozmiar pliku"
                          invalidFileSizeMessageDetail="maksymalny rozmiar pliku: {0}">
            </p-fileUpload>
            <small *ngIf="attachmentsFormDirty && !registerFile" class="p-error">
                Brak pliku z odpisem
            </small>
        </div>
    </li>
</ul>